__turbopack_context__.v({
  "input-row": "textarea-module-scss-module__9Scltq__input-row",
  "input-row-disabled": "textarea-module-scss-module__9Scltq__input-row-disabled",
  "input-row-error": "textarea-module-scss-module__9Scltq__input-row-error",
  "input-row-success": "textarea-module-scss-module__9Scltq__input-row-success",
  "sub-label": "textarea-module-scss-module__9Scltq__sub-label",
  "wrapper": "textarea-module-scss-module__9Scltq__wrapper",
});
